import React, { useMemo, useState } from "react";
import { json, useLocation, useNavigate } from "react-router-dom";
import './OptionManagement.css';
import { useEffect } from "react";
import httpClient from "../../HTTPService";
import { ToastContainer, toast } from 'react-toastify';
const AddEditOption = () => {
    const navigate = useNavigate();
    const location = useLocation()
    const [optionName, setOptionName] = useState('');
    const [optionValue, setOptionValue] = useState('');
    const [editMode, setEditMode] = useState();
    const [editid, setEditID] = useState();
    const [optionData, setOptiondata] = useState([]);
    const queryParams = new URLSearchParams(location.search); // Parse query string
    const id = queryParams.get('id');
    // let textInput = React.createRef()

    const [select_state_id, set_select_stateid] = useState(null)
    const [state_data, set_state_Data] = useState([])
    const [updateOptionData, setUpdateOptionData] = useState([])
    function ondeleteItems(indexs) {
        let _modifiedarray = optionData?.filter((obj, index) => index !== indexs)
        let _deleteditem = optionData[indexs]
        if (_deleteditem?.id != null) {
            _deleteditem['deleted'] = true
            _modifiedarray.push(_deleteditem)
        }
        setOptiondata(_modifiedarray)
    }

    useEffect(() => {
        if (id != undefined) {
            // setloadinigstate(true)
            httpClient.post("/admin/option-masters/view", {
                "id": id
            }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }).then((res) => {

                if (id == 2) {
                    setOptionName(res?.data?.data?.name)

                    let _setactualData = res?.data?.states?.map((item) => {
                        return {
                            value: item?.id,
                            lebel: item?.option_name
                        }
                    })
                    set_state_Data(_setactualData)
                    return
                }
                setOptionName(res?.data?.data?.name)
                let _setactualData = res?.data?.data?.options?.map((item) => {
                    return {
                        id: item?.id,
                        name: item?.option_name,
                        deleted: item?.deleted !== undefined ? item?.deleted : false
                    }
                })
                setOptiondata(_setactualData)
            })

        }

        // console.log(result ,'category details')
    }, [id])



    const updateoption = (index1, optionValue) => {
        let data = [...optionData]
        data[index1].name = optionValue?.target?.value
        setOptiondata(data)

    };
    const addoption = () => {
        setOptiondata(prevOptionData => {
            if (prevOptionData && prevOptionData?.length > 0) {
                return [...prevOptionData, { id: null, name: optionValue }];
            } else {
                return [{ id: null, name: optionValue }];
            }
        });
        setOptionValue('');
    };
    const addOptionForm = async () => {
        console.log(optionData, 'option data')
        if (id != undefined) {

            try {
                console.log(optionData, 'option data>>>>>>>>>>>>>>>>>>>>>>>')
                const result = await httpClient.post("/admin/option-masters/update", { id: id, name: optionName, option_data: optionData, parent_id: select_state_id }, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                })
                if (result.data.status == true) {
                    setTimeout(() => {
                        navigate('/optionmanagement')
                    })
                    toast.success("Option Update Successfully")
                }

            }
            catch (error) {
                toast.error(error.message)
            }
        }
        else {
            try {
                const result = await httpClient.post("/admin/option-masters/create", { name: optionName, option_data: optionData }, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                })
                if (result.data.status == true) {
                    setTimeout(() => {
                        navigate('/optionmanagement')
                    })
                    toast.success("Option Create Successfully")
                }
                if (result.data.status == false) {
                    toast.error(result.data.message)
                }
            }
            catch (error) {
                toast.error(error.message)
            }
        }

    }


    useMemo(() => {
        fetchdistriclist(select_state_id)
    }, [select_state_id])
    // fetch distric list by state id
    async function fetchdistriclist(id) {
        httpClient.post("/admin/option-child-list", {
            "id": id
        }, {
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
                'Authorization': `Bearer ${localStorage.getItem('token')}`
            }
        }).then((data) => {
            let _setactualData = data?.data?.data?.map((item) => {
                return {
                    id: item?.id,
                    name: item?.option_name
                }
            })
            setOptiondata(_setactualData)
        })
    }
    return (
        <div className="AddEditOption">
            <ToastContainer
                autoClose={1000}
            />
            <div className="card">

                <div className="row">
                    <div className="col-md-4">
                        {
                            id == 2 ? (
                                <div className="search-box" >
                                    <div class="searchtct " style={{
                                        // paddingRight: 20
                                    }}>
                                        <select
                                            value={select_state_id}
                                            // className='ml-3'
                                            // disabled={chooseFldType ===     '' ? true : false}
                                            onChange={(val) => {
                                                console.log(val, 'valfiodsfiosf')
                                                set_select_stateid(val?.target?.value)
                                                // if (val.target.value == 1 || val.target.value == 2 || val.target.value == null) {
                                                // navigate('/member/paid')
                                                // setfilter(val.target.value)
                                                // } else {
                                                //     setfilter(val.target.value)

                                                // }

                                            }}
                                        //   className={(isrequired && labelvalue === null) ? 'required' :'' }
                                        >
                                            <option value={null} >Select state</option>
                                            {
                                                state_data?.map((item) => {
                                                    return (
                                                        <>
                                                            <option value={item?.value} >{item?.lebel}</option>
                                                        </>
                                                    )
                                                })
                                            }

                                        </select>
                                    </div>
                                </div>
                            )
                                :
                                (
                                    <div className="formGroup">
                                        <label>Option Name</label>
                                        <input type="text" name="optionName" placeholder="Name" onChange={(val) => setOptionName(val.target.value)} value={optionName} required />
                                    </div>
                                )
                        }






                    </div>
                </div>
                <div className="scrollBar">
                    {/* {optionData? optionData?.map((item, index)=>{
                         return  <div className="row" key={index}>
                         <div className="col-md-4">
                            <div className="formGroup ">
                            <input type="text" name="optionValue" placeholder="Option Value" value={item.name}/>
                            </div>
                        </div>
                        </div>
                     
                       
                    })} */}
                    {

                        // editMode ?
                        // optionData?.map((item, index) => {
                        //     return <div className="row" key={index}>
                        //         <div className="col-md-4">
                        //             <div className="formGroup ">
                        //                 <input type="text" name="optionValue" placeholder="Option Value" defaultValue={item.name} onChange={(val) => { updateoption(index, val.target.value) }} />
                        //             </div>
                        //         </div>
                        //     </div>

                        // }) :
                        optionData?.filter(item => item.deleted !== true).map((item, index) => {
                            return (
                                <div className="row" key={index}>
                                    <div className="col-md-4">
                                        <div className="formGroup ">
                                            <div className="item-list">
                                                <input type="text"
                                                    name="optionValue" placeholder="Option Value"
                                                    value={item.name}
                                                    onChange={(val) => { updateoption(index, val) }}

                                                />
                                                <div className="cross-icon" onClick={() => ondeleteItems(index)}>
                                                    <div className="">
                                                        <p className="icon">X</p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )



                        })

                    }
                </div>


                <div className="row">
                    <div className="col-md-4">

                        <div className="formGroup flxFrm">
                            <input type="text" name="optionValue" value={optionValue} placeholder="Option Value" onChange={(val) => { setOptionValue(val.target.value) }} />
                            <button type="button" className="addBtn"
                                disabled={optionValue === '' ? true : false}
                                onClick={addoption} >Add</button>
                        </div>


                    </div>
                </div>

                <div className="row">
                    <div className="col-md-4">
                        <div className="btngrp">
                            <button type="button" className="themeBtn cancelBtn" onClick={() => { navigate('/optionmanagement'); localStorage.removeItem('editOptions') }}>Cancel</button>
                            <button type="submit" className="themeBtn"
                                disabled={(select_state_id == null && optionName == '') ? true : false}
                                onClick={addOptionForm}>{editMode ? "Update" : "Submit"}</button>
                        </div>
                    </div>
                </div>


            </div>
        </div>

    )
}
export default AddEditOption;